const minimize = () => {
    window.closer.hideButton();
    window.closer.showButton();
};

export default minimize;
